<script>
import Widget from '../../Widget.vue';
import { useSearchableSelector } from '../../../composables/useSearchableSelector'
import {nextTick} from "vue";

export default {
    extends: Widget,
    name: "InvestmentType",
    emits: ['event-investment-type', 'emitFormStarted'],
    data() {
        return {
            InvestmentType: null,
        }
    },

    mounted() {
        this.render();
    },

    methods: {
        async render() {
            this.block();
            const {initSearchableSelector} = useSearchableSelector()
            await nextTick()
            initSearchableSelector("investmentType");
            this.unblock();
        },

        updateInvestmentType() {
            if (this.InvestmentType) {
                this.$emit('emitFormStarted', this.InvestmentType);
            }
        },
    }
}
</script>

<template>
    <div class="investment-application-form">
        <section class="investment-application-type">
            <div class="form-group form-group-selectr investment-type-form">
                <label for="investor">
                    Select an Investment Type
                </label>
                <select id="investmentType" class="form-control" name="" @change="updateInvestmentType" v-model="InvestmentType" required>
                    <option value="">Select investment type</option>
                    <option value="isa-application">ISA Application</option>
                </select>
            </div>
        </section>
    </div>
</template>

<style scoped>

</style>
